import React from 'react'

const WaysToEarnHighlight = ({
	className = '',
	icon,
	title,
	highlight,
}) => {
	return (
		<React.Fragment>
			<div className={`p-2 inline-flex items-center gap-x-2 rounded-md ${className} w-full bg-white md:border md:border-gray-300`}>
				<div className='p-2'>
					{ icon }
				</div>
				<div className='space-y-1 text-black text-left'>
					<p className='text-sm font-medium'>{title}</p>
					<p className='text-xs text-[#4F4F4F] max-w-[434px]'>{highlight}</p>
				</div>
			</div>
		</React.Fragment>
	)
}

export default WaysToEarnHighlight